import type { FunctionComponent } from "react";

import { PostiesAdditionalLinkTags } from "scmp-app/components/meta/consts";
import PostiesImage from "scmp-app/components/posties/posties-seo/posties-image.png";
import { SectionSeo } from "scmp-app/components/section/section-seo";
import type { sectionSeoSection$key } from "scmp-app/queries/__generated__/sectionSeoSection.graphql";

type Props = {
  reference: sectionSeoSection$key;
};

export const PostiesSectionSeo: FunctionComponent<Props> = ({ reference }) => (
  <SectionSeo
    additionalLinkTags={PostiesAdditionalLinkTags}
    additionalMetaTags={undefined}
    openGraph={{
      images: [{ url: PostiesImage.src }],
    }}
    options={{
      customMerge(key) {
        if (key === "additionalLinkTags") {
          return (_, source: unknown[]) => source;
        }
      },
    }}
    reference={reference}
  />
);

PostiesSectionSeo.displayName = "PostiesSectionSeo";
